const numberFormats = {
  fr: {
    kilometer: {
      style: "unit",
      unit: "kilometer",
      unitDisplay: "short",
      maximumFractionDigits: 0,
    },
  },
  pt: {
    kilometer: {
      style: "unit",
      unit: "kilometer",
      unitDisplay: "short",
      maximumFractionDigits: 0,
    },
  },
};

export default numberFormats;
